const LoadingSpinner = ({ message = 'Φόρτωση...' }) => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#1A202C' }}>
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div
            className="w-16 h-16 mx-auto mb-4 rounded-full animate-spin"
            style={{
              background: 'conic-gradient(from 0deg, transparent 0%, #10B981 50%, #06B6D4 100%)',
              WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #fff calc(100% - 4px))',
              mask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #fff calc(100% - 4px))'
            }}
          />
          <p className="text-gray-400 text-sm animate-pulse">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
